(() => {
  const popup=document.createElement('div');
  popup.id='FpTaxHelp'; popup.className='fp-tax-popover'; popup.role='tooltip'; popup.hidden=true;
  document.body.append(popup);
  let active=null;
  function close() {
    if(active){active.setAttribute('aria-expanded','false');active.removeAttribute('aria-describedby');}
    active=null;popup.hidden=true;
  }
  function position() {
    if(!active?.isConnected){close();return;}
    const r=active.getBoundingClientRect(),h=popup.offsetHeight,w=popup.offsetWidth;
    popup.style.left=Math.max(12,Math.min(r.left+r.width/2-w/2,innerWidth-w-12))+'px';
    popup.style.top=Math.max(12,Math.min(r.bottom+8+h>innerHeight-12?r.top-h-8:r.bottom+8,innerHeight-h-12))+'px';
  }
  document.addEventListener('click',event=>{
    const trigger=event.target.closest('[data-tax-help]');
    if(trigger){event.preventDefault();event.stopPropagation();if(active===trigger){close();return;}close();active=trigger;popup.textContent=trigger.dataset.taxHelp;popup.hidden=false;trigger.setAttribute('aria-expanded','true');trigger.setAttribute('aria-describedby',popup.id);position();}
    else if(!popup.contains(event.target))close();
  },true);
  document.addEventListener('keydown',event=>{if(event.key==='Escape'&&active){const trigger=active;close();trigger.focus();event.stopPropagation();}},true);
  document.addEventListener('focusin',event=>{if(active&&event.target!==active&&!popup.contains(event.target))close();});
  window.addEventListener('resize',()=>{if(active)position();});
  document.addEventListener('scroll',()=>{if(active)position();},true);
})();
